import { useEffect, useState } from "react";
import styled from "styled-components";
import Layout from "../../components/layout";
import { Button, Grid2 as Grid } from "@mui/material";
import {
  Bitcoin,
  ETH,
  DashboardWallet,
} from "../../shared/icons";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import {
  getOwnerNFTs,
  getTrendingNFTs,
  getWalletBalance,
  syncOwnerNFTs,
} from "../../slices/dashboard/dashboardThunks";
import Loader from "../../components/shared-components/Loader";
import OverviewChart from "../../pages/CollectionDetails/PieChart";
import { screenSizes } from "../../styles/theme";
import TrendingNFTs from "./TrendingNFTs";
import OwnerNFTs from "./OwnerNFTs";

import { Magic } from 'magic-sdk';
import { HederaExtension } from '@magic-ext/hedera';

import { ethers } from "ethers";
import { AccountBalanceQuery, Client,LedgerId } from "@hashgraph/sdk";

import { textTransform } from "html2canvas/dist/types/css/property-descriptors/text-transform";

// Header and title
const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  @media (max-width: ${screenSizes.L}px) {
    margin-top: 4rem;
    margin-bottom: 0.5rem;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  @media (max-width: ${screenSizes.L}px) {
    margin-bottom: 0.5rem;
  }
`;

const TitleContainer = styled.div`
  color: #091c00;
  h2 {
    font-family: "Manrope", sans-serif;
    font-size: 50px;
    font-weight: 700;
    margin: 0;
    letter-spacing: -2px;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 32px;
      line-height: 50px;
      letter-spacing: 0;
    }
  }
`;

// dashboard
const DashboardSection = styled.section`
  padding: 80px;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
  }
`;

const InfoSection = styled.div`
  height: 366px;
  width: 100%;
  border: 1px solid #091c001a;
  background-color: #fff;
  overflow: hidden;
  h1 {
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 24px;
  }
  @media (max-width: ${screenSizes.L}px) {
    height: auto;
  }
`;

const ButtonContained = styled.button`
  outline: none;
  border: none;
  border-radius: 80px;
  padding: 16px 20px;
  background-color: #ff9d59;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
`;

const BalanceSection = styled.div`
  height: 366px;
  background: url(${DashboardWallet}) no-repeat center center;
  background-size: cover;
  padding: 48px;
  gap: 10px;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1.5rem;
  }
`;

const WalletCard = styled.div`
  margin-bottom: 30px;
  border-bottom: 1px solid #ffffff;
`;

const WalletDetails = styled.div`
  margin-bottom: 30px;
  h6 {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 19.12px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #ffffff;
  }
  h1 {
    margin: 0;
    font-family: Manrope;
    font-size: 36px;
    font-weight: 800;
    line-height: 49.18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #ffffff;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Limit to 3 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 28px;
    }
  }
`;

const ProfitDetails = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 20px;
  div {
    h6 {
      margin: 0;
      font-family: Manrope;
      font-size: 14px;
      font-weight: 700;
      line-height: 19.12px;
      color: #fff;
    }
    h2 {
      margin: 0;
      font-family: Manrope;
      font-size: 24px;
      font-weight: 600;
      line-height: 32.78px;
      color: #fff;
    }
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 25px;
    padding: 5px 14px;
    border-radius: 100px;
    opacity: 0px;
    color: #fff;
    background: rgba(255, 255, 255, 0.23);
  }
`;

// Status Section
const StatusSection = styled.section`
  padding: 80px;
  padding-top: 0;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
  }
`;

const TransactionSection = styled.div<{containData: boolean}>`
  height: ${(props) => (props.containData ? "441px" : "auto")};
  background: ${(props) => (props.containData ? "#fff" : "transparent")};
  border: ${(props) => (props.containData ? "1px solid rgba(9, 28, 0, 0.1)" : "none")};
  padding: ${(props) => (props.containData ? "20px" : "0px")};
  overflow: scroll;
  @media (max-width: ${screenSizes.L}px) {
    height: ${(props) => (props.containData ? "300px" : "auto")};
  }
`;

const TransactionCard = styled.div`
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid #eaeaea;
  }

  .info {
    display: flex;
    align-items: center;
    gap: 10px;
    .icon {
    }
    .details {
      display: flex;
      flex-direction: column;

      .unit {
        font-family: Manrope;
        font-size: 16px;
        font-weight: 700;
        line-height: 21.86px;
        color: #091c00;
      }

      .pricing {
        font-family: Manrope;
        font-size: 12px;
        font-weight: 400;
        line-height: 16.39px;
        color: rgba(9, 28, 0, 0.6);
      }
    }
  }
  .price {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 600;
    line-height: 21.86px;
    color: #091c00;
  }
`;

interface Wallet {
  balance: string;
  profit: string;
  profitPercent: string;
  leaderBoard: string;
}

interface OwnerNFTsRecord {
  id: string;
  image: string;
  symbol: string;
  name: string;
  amount: string | number;
}

interface Transaction {
  id: string;
  value: string;
}

interface TrendingNFTsRecord {
  id: string;
  image: string;
  nftType: string;
  nftName: string;
  price: number;
  ecoScore: number;
  networkId: string | number;
}

interface Loading {
  balance: boolean;
  transactions: boolean;
  trendingNFTs: boolean;
  ownerNFTs: boolean;
}

interface Page {
  trendingNFTs: number;
  ownerNFTs: number;
}

interface LoadingMore {
  trendingNFTs: boolean;
  ownerNFTs: boolean;
}

const Dashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const token = useSelector((state: RootState) => state.auth.token);
  const walletAddress = useSelector(
    (state: RootState) => state.auth.user.walletAddress
  );

  const [ walletAuthTypeLocal, setwalletAuthTypeLocal ] = useState<string>('');
  const [ walletAmount, setwalletAmount ] = useState<string>('0.0000 ETH');

  const [walletDetails, setWalletDetails] = useState<Wallet | null>(null);
  const [transactions, setTransactions] = useState<Transaction[] | []>([]);
  const [ownerNFTs, setOwnerNFTs] = useState<OwnerNFTsRecord[] | []>([]);
  const [trendingNFTs, setTrendingNFTs] = useState<TrendingNFTsRecord[] | []>(
    []
  );
  const [isLoading, setIsLoading] = useState<Loading>({
    balance: false,
    transactions: false,
    trendingNFTs: false,
    ownerNFTs: false,
  });
  const [currentPage, setCurrentPage] = useState<Page>({
    trendingNFTs: 1,
    ownerNFTs: 1,
  });
  const [totalPages, setTotalPages] = useState<Page>({
    trendingNFTs: 1,
    ownerNFTs: 1,
  });
  const [isLoadingMore, setIsLoadingMore] = useState<LoadingMore>({
    trendingNFTs: false,
    ownerNFTs: false,
  });

  const syncOwnerNFTRecords = () => {
    // dispatch(syncOwnerNFTs("0x7784f9a68be6818e160843b7282512d1e9013fff"))
    if (walletAddress) {
      dispatch(syncOwnerNFTs(walletAddress))
        .then((res: any) => {
          console.log("res", res);
          if (res?.error) {
            throw new Error(res?.payload);
          }
        })
        .catch((err) => {
          console.log({err})
        })
        .finally(() => {});
    }
  };

  const getWalletDetails = () => {
    setIsLoading((prev: any) => ({
      ...prev,
      balance: true,
      transactions: true,
    }));
    if (walletAddress) {
      dispatch(
        getWalletBalance({
          walletAddress: walletAddress,
          chain: process.env.REACT_APP_CHAIN,
        })
      )
        .then((res: any) => {
          console.log("res 1", res?.payload?.data?.data?.walletDetails);
          if (res?.error) {
            throw new Error(res?.payload);
          }
          const wallet = res?.payload?.data?.data?.walletDetails;
          setWalletDetails({
            balance: wallet?.balance?.balance || "0.00",
            profit: wallet?.profit || "0.00",
            profitPercent: wallet?.profitPercent || "0.00",
            leaderBoard: wallet?.leaderboard || "0",
          });
          const transactions =
            res?.payload?.data?.data?.walletDetails?.transactionHistory?.result?.map(
              (item: any) => ({
                id: item?.hash,
                value: item?.value,
              })
            );
          setTransactions(transactions);
        })
        .catch((err) => {
          console.log({err})
          setTransactions([]);
        })
        .finally(() => {
          setIsLoading((prev: any) => ({
            ...prev,
            balance: false,
            transactions: false,
          }));
        });
    }
  };

  const getOwnerNFTRecords = () => {
    setIsLoading((prev: any) => ({
      ...prev,
      ownerNFTs: true,
    }));
    // dispatch(getOwnerNFTs(process.env.REACT_APP_WALLET_ADDRESS))
    if (walletAddress && token) {
      dispatch(
        getOwnerNFTs({
          walletAddress,
          token
        })
      )
        .then((res: any) => {
          console.log("res2", res);
          if (res?.error) {
            throw new Error(res?.payload);
          }
          const mappedOwnerNFTs = res?.payload?.data?.data?.map((nft: any) => ({
            id: nft?._id,
            image: nft?.token_uri,
            symbol: nft?.symbol || "--",
            name: nft?.name || "--",
            amount: nft?.amount || "0.00",
          }));
          setOwnerNFTs(mappedOwnerNFTs);
        })
        .catch((err) => {
          console.log({err})
          setOwnerNFTs([]);
        })
        .finally(() => {
          setIsLoading((prev: any) => ({
            ...prev,
            ownerNFTs: false,
          }));
        });
    }
  };

  const getTrendingNFTsList = (
    name: string = "",
    blockchain_network: string = "",
    rank_by: string = "",
    category_id: string = "",
    eco_category_id: string = "",
    limit: number = 10,
    pageNo: number = 1,
    isLoadingMore: boolean = false
  ) => {
    setIsLoading((prev: any) => ({
      ...prev,
      trendingNFTs: !isLoadingMore,
    }));
    setIsLoadingMore((prev: any) => ({ ...prev, trendingNFTs: isLoadingMore }));
    const network = blockchain_network === "all" ? "" : blockchain_network;
    const category = category_id === "all" ? "" : category_id;
    const ecoCategory = eco_category_id === "all" ? "" : eco_category_id;
    dispatch(
      getTrendingNFTs({
        limit,
        page: pageNo,
        name,
        blockchain_network: network,
        rank_by,
        category_id: category,
        eco_category_id: ecoCategory,
      })
    )
      .then((res: any) => {
        console.log("res nfts", res?.payload?.data);
        if (res?.error) {
          throw new Error(res?.payload);
        }
        setTotalPages((prev: any) => ({
          ...prev,
          trendingNFTs: res?.payload?.data?.meta?.totalPages,
        }));
        setCurrentPage((prev: any) => ({
          ...prev,
          trendingNFTs: res?.payload?.data?.meta?.currentPage,
        }));
        const mappedNFTs = res?.payload?.data?.data?.map((item: any) => ({
          id: item?._id,
          image: item?.fileUrl,
          nftName: item?.name || "--",
          nftType: item?.nftType || "--",
          price: item?.price || "0",
          ecoScore: item?.score || "0",
          networkId: item?.networkId || 1,
        }));
        const currentPage = res?.payload?.data?.meta?.currentPage;
        if (pageNo === 1 && !isLoadingMore) {
          // Initial load or applying filters (reset data)
          setTrendingNFTs(mappedNFTs);
        } else if (isLoadingMore && currentPage > 1) {
          // Loading more NFTs (append data)
          setTrendingNFTs((prevRecords: any) => [
            ...prevRecords,
            ...mappedNFTs,
          ]);
        } else if (
          !name &&
          !blockchain_network &&
          !rank_by &&
          !category_id &&
          !eco_category_id
        ) {
          // No filters applied (initial unfiltered load or reset)
          setTrendingNFTs((prevRecords: any) => [
            ...prevRecords,
            ...mappedNFTs,
          ]);
        } else {
          // Filters applied (reset data)
          setTrendingNFTs(mappedNFTs);
        }
      })
      .catch((err) => {
        console.log({err})
        setTrendingNFTs([]);
      })
      .finally(() => {
        setIsLoading((prev: any) => ({ ...prev, trendingNFTs: false }));
        setIsLoadingMore((prev: any) => ({ ...prev, trendingNFTs: false }));
      });
  };

  useEffect(() => {
    
    syncOwnerNFTRecords();
    getWalletDetails();
    getOwnerNFTRecords();
    getTrendingNFTsList();
    
    getUserWalletBalance();
    

    let walletAuthType = localStorage.getItem('walletAuthType');
    setwalletAuthTypeLocal(walletAuthType || "none");

  }, []);


 

  const magic = new Magic(process.env.REACT_APP_MAGIC_PUBIC_KEY || "", {
    network: "sepolia", // Ethereum testnet
  });


  const magicHedara = new Magic(process.env.REACT_APP_MAGIC_PUBIC_KEY || "", {
    extensions: [new HederaExtension({
      network: 'testnet' // 'mainnet' or 'testnet'
    })]
  });

  const magicViewHBARKey = async() => {
    magicHedara.user.isLoggedIn().then(async magicIsLoggedIn => {
        
      if (magicIsLoggedIn) {
        const publicAddress:any = (await magicHedara.user.getMetadata()).publicAddress;

        console.log('publicAddress',publicAddress);
        alert('Magic HBAR Key='+publicAddress)

      }
    });
  }

  const magicViewWallet = async() => {
    try {
    const userInfo = await magic.wallet.showUI()
      console.log('userInfo', userInfo); // the user's email if they consented.
    } catch (error) {
      console.log('errorerror',error);
      // Handle errors if required!
    }
  }

  const magicExportKey = async() => {
    try {
      await magic.user.revealPrivateKey();
      console.log('exportMagicLinkKey called successfully')
    } catch (error) {
      console.log('errorerror',error);
      // Handle errors if required!
    }
  }

  // Detect multiple providers
const getProvider = () => {
  if (window.ethereum?.providers) {
    return {
      metamask: window.ethereum.providers.find((p:any) => p.isMetaMask),
      coinbase: window.ethereum.providers.find((p:any) => p.isCoinbaseWallet),
    };
  }
  return { metamask: window.ethereum, coinbase: null }; // Fallback for a single provider
};

// Fetch balance for a given provider
const getBalanceAmount = async (provider:any, walletName:any) => {
  console.log('getBalanceAmount provider', provider)
  console.log('getBalanceAmount walletName', walletName)
  if (!provider) {
    console.log(`${walletName} provider not found`);
    return;
  }

  const ethersProvider = new ethers.providers.Web3Provider(provider);
  const accounts = await ethersProvider.listAccounts();
  console.log('accountsaccounts',accounts);
  if (accounts.length > 0) {
    const balance = await ethersProvider.getBalance(accounts[0]);
    console.log(`${walletName} Balance: ${ethers.utils.formatEther(balance)} ETH`);

    const getBalance = parseFloat(ethers.utils.formatEther(balance)).toFixed(6);
    console.log(`getBalance: ${getBalance} ETH`); // Convert

    setwalletAmount(`${getBalance} ETH`);

  } else {
    console.log(`No accounts found in ${walletName}`);
  }
};


// Function to Fetch HBAR Balance
async function getHbarBalance(accountId:string) {
  try {
    const client = Client.forTestnet(); // Change to `Client.forMainnet()` for Mainnet
    const balanceQuery = new AccountBalanceQuery().setAccountId(accountId);
    const balance = await balanceQuery.execute(client);

    console.log(`Wallet Balance: ${balance.hbars.toString()} HBAR`);

    const getBalance = parseFloat(balance.hbars.toString()).toFixed(6);
    setwalletAmount(`${getBalance} HBAR`);

  } catch (error) {
    console.error("Error fetching balance:", error);
  }
}


  const getUserWalletBalance = async() => {
    console.log('getWalletBalance called walletAddress', walletAddress);
    let walletAuthType = localStorage.getItem('walletAuthType');
    console.log('walletAuthType', walletAuthType);
      if(walletAuthType == 'MetaMask'){
        const { metamask } = getProvider();
        await getBalanceAmount(metamask, "MetaMask");
      }else if(walletAuthType == 'Coinbase'){
        const { coinbase } = getProvider();
        await getBalanceAmount(coinbase, "Coinbase Wallet");
      }else if(walletAuthType == 'Hashpack'){

        // const accountId = "0.0.5474668";

        // Fetch and display balance
        getHbarBalance(walletAddress || "");

        // const response = await fetch(`https://testnet.mirrornode.hedera.com/api/v1/accounts/${accountId}`);
        // const data = await response.json();
        // console.log('datadata',data);
        // console.log(`Wallet Balance: ${data.balance.balance / 1_000_000_000} HBAR`); // Convert tinybars to HBAR      
      }

  }

  return (
    <Layout fullScreen>
      {/* dashboard section */}
      <DashboardSection>
        <HeaderContainer>
          <TitleContainer>
            <h2>Dashboard</h2>
          </TitleContainer>
          {walletAuthTypeLocal === 'Magiclink' ? 
          <div>
          <Button style={{textTransform:"capitalize", textDecoration:"underline"}} onClick={magicViewHBARKey}>View HBAR Wallet Address</Button>
          <Button style={{textTransform:"capitalize", textDecoration:"underline"}} onClick={magicViewWallet}>View ETH Wallet Address</Button>
          <Button style={{textTransform:"capitalize", textDecoration:"underline"}} onClick={magicExportKey}>Export Key</Button>
          </div>
          : null}

        </HeaderContainer>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 7 }}>
            <InfoSection>
              <OverviewChart
                // walletAddress={"0x7784f9a68be6818e160843b7282512d1e9013fff"}
                walletAddress={walletAddress}
              />
            </InfoSection>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <BalanceSection>
              <WalletCard>
                <WalletDetails>
                  <h6>Wallet Balance</h6>
                  <h1 title={walletDetails?.balance}>
                    {walletAmount}
                  </h1>
                </WalletDetails>
                <ProfitDetails>
                  <div>
                    <h6>Monthly Profit</h6>
                    <h2>${walletDetails?.profit}</h2>
                  </div>
                  <span>+{walletDetails?.profitPercent}%</span>
                </ProfitDetails>
              </WalletCard>
              <WalletDetails>
                <h6>Leaderboard</h6>
                <h1>#{walletDetails?.leaderBoard}</h1>
              </WalletDetails>
            </BalanceSection>
          </Grid>
        </Grid>
      </DashboardSection>
      {/* Status section */}
      <StatusSection>
        <Grid container spacing={2}>
          
          <Grid size={{ xs: 12, md: 12 }}>
            <HeaderWrapper>
              <TitleContainer>
                <h2>Recent Transactions</h2>
              </TitleContainer>
            </HeaderWrapper>
            <TransactionSection containData={transactions?.length > 0}>
              {isLoading?.transactions ? (
                <Loader />
              ) : transactions?.length > 0 ? (
                transactions?.map((item) => (
                  <TransactionCard key={item?.id}>
                    <div className="info">
                      {process.env.REACT_APP_CHAIN === "eth" ? (
                        <ETH />
                      ) : (
                        <Bitcoin className="icon" />
                      )}
                    </div>
                    <div className="price">-${item?.value}</div>
                  </TransactionCard>
                ))
              ) : (
                <div>No Transactions Found!</div>
              )}
            </TransactionSection>
          </Grid>
        </Grid>
      </StatusSection>
      {/* Owner section */}
      <OwnerNFTs isLoading={isLoading.ownerNFTs} ownerNFTs={ownerNFTs} />
      {/* Trending NFTs */}
      <TrendingNFTs
        isLoading={isLoading?.trendingNFTs}
        isLoadingMore={isLoadingMore.trendingNFTs}
        trendingNFTs={trendingNFTs}
        currentPage={currentPage.trendingNFTs}
        totalPages={totalPages.trendingNFTs}
        getTrendingNFTsList={getTrendingNFTsList}
      />
    </Layout>
  );
};

export default Dashboard;
